<template>
  <v-container fluid class="pa-6 pa-md-8">
    <div class="page-head">
      <h1 class="page-head__title">Schools</h1>
      <p class="page-head__sub">All schools registered on the platform.</p>
    </div>

    <v-data-table
      :headers="headers"
      :items="allSchools"
      :loading="pageLoading"
      :server-items-length="paginate.total"
      :options.sync="options"
      class="data-table"
      loading-text="Loading… Please wait"
      :footer-props="{ itemsPerPageOptions: [30, 40, 50] }"
    >
      <template #item.name="{ item }">
        <div class="d-flex align-center">
          <v-avatar size="34" class="cell-avatar mr-3">
            <v-icon size="18">mdi-school-outline</v-icon>
          </v-avatar>
          <span class="cell-strong text-capitalize">{{ item.name }}</span>
        </div>
      </template>
      <template #item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              :to="{
                name: 'admin.schools.students',
                params: { id: item._id },
                query: { name: item.name }
              }"
              v-on="on"
              icon
              small
              class="cell-action"
            >
              <v-icon small>mdi-account-school-outline</v-icon>
            </v-btn>
          </template>
          <span>View students</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              :to="{
                name: 'admin.schools.transactions',
                params: { id: item._id },
                query: { name: item.name }
              }"
              v-on="on"
              icon
              small
              class="cell-action"
            >
              <v-icon small>mdi-cash-multiple</v-icon>
            </v-btn>
          </template>
          <span>View all transactions</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <SnackBar
      :showSnackBar="showSnackBar"
      :message="message"
      :status="status"
    />
  </v-container>
</template>

<script>
import { debounce } from "lodash";
import { loadComponent } from "@/utils/helpers";
import { mapGetters } from "vuex";
import SnackBarMixins from "../../../../mixins/SnackBarMIxins";
export default {
  name: "AllStaffs",
  data() {
    return {
      options: {},
      search: "",
      searchTerm: null
    };
  },
  components: {
    SnackBar: loadComponent(`component/SnackBar`)
  },

  computed: {
    ...mapGetters({
      allSchools: "schools/getAllSchools",
      pageLoading: "getIsPageLoading",
      isLoading: "getIsLoading",
      paginate: "schools/getPagination"
    }),
    form() {
      return {
        name: this.name,
        phone: this.phone,
        accountNumber: this.accountNumber
      };
    },
    staffList() {
      return this.allStaff.filter(searchTerm => {
        return (
          searchTerm.name.toLowerCase().indexOf(this.search.toLowerCase()) !==
          -1
        );
      });
    },

    headers() {
      return [
        {
          text: "Name",
          value: "name",
          filterable: true,
          sortable: false
        },
        {
          text: "Actions",
          value: "actions"
        }
      ];
    }
  },
  filters: {
    status(value) {
      return !value ? "Active" : "Inactive";
    },
    firstLetterFunction(value) {
      return value.charAt(0).toUpperCase();
    }
  },
  mixins: [SnackBarMixins],
  watch: {
    search: debounce(function(value) {
      if (value === "") {
        this.searchTerm = null;
        this.$store.dispatch(
          "members/list",
          `?page=1&size=30${
            this.activeAccountType ? "&accType=" + this.activeAccountType : ""
          }`
        );
        return;
      }
      this.searchTerm = value;
      const query = `?searchTerm=${value}&page=1&size=30${
        this.activeAccountType ? "&accType=" + this.activeAccountType : ""
      }`;
      this.$store.dispatch("members/searchList", query);
    }, 500),
    options: {
      handler(value) {
        const { itemsPerPage, page } = value;
        const query = `?page=${page}&size=${itemsPerPage}${
          this.activeAccountType ? "&accType=" + this.activeAccountType : ""
        }${this.searchTerm ? "&searchTerm=" + this.searchTerm : ""}`;
        if (this.searchTerm) {
          this.$store.dispatch("members/searchList", query);
        } else {
          this.$store.dispatch("members/list", query);
        }
      },
      deep: true
    },
    activeAccountType(value) {
      if (value) {
        const query = `?page=1&size=30&accType=${value}`;
        this.$store.dispatch("members/list", query);
        return;
      }
      const query = `?page=1&size=30`;
      this.$store.dispatch("members/list", query);
    }
  },
  methods: {},
  created() {
    const query = `?page=1&size=30`;
    this.$store.dispatch("schools/list", query);
  }
};
</script>

<style scoped>
.cell-avatar {
  background: var(--signal-soft);
  color: var(--signal);
}
.cell-avatar .v-icon {
  color: var(--signal);
}
.cell-strong {
  font-weight: 600;
  color: var(--foreground);
}
.cell-action {
  color: var(--muted-foreground) !important;
  margin: 0 2px;
}
.cell-action:hover {
  color: var(--signal) !important;
}
</style>
